import { render, staticRenderFns } from "./QRCodeDialog.vue?vue&type=template&id=e458a1f4&scoped=true&"
import script from "./QRCodeDialog.vue?vue&type=script&lang=js&"
export * from "./QRCodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeDialog.vue?vue&type=style&index=0&id=e458a1f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e458a1f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Imglazy: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/Imglazy.vue').default})
